import { BoletoFisicoComponent } from './boleto-fisico/boleto-fisico.component';
import { ItauComponent } from './itau.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormComponent } from './form/form.component';

const routes: Routes = [
  {
    path: '', component: ItauComponent, children: [
      { path: 'fisico', component: BoletoFisicoComponent },
      { path: 'fisico/:id', component: BoletoFisicoComponent },
      { path: 'form', component: FormComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ItauRouting { }
